import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
//primereact
import { Button } from "primereact/button";
//components

import Modal from "../../../../../../../components/modal/Modal";

//services
import Toggle from "../../../../../../../components/button/Toggle";

import { ModalRegisterSigners } from "./ModalRegisterSigners.jsx";
import { InputTextarea } from "primereact/inputtextarea";
import Input from "../../../../../../../components/input/Input.js";
import { postSendContract } from "../../../../../../../services/Enterprise/ClickSign/postSendContract.js";
import Select from "../../../../../../../components/input/Select.js";

export const ModalSendSign = ({
  visible,
  setVisible,
  defaultValues,
  idSale,
  idClient,
  newSigner,
  isLoadingSigners,
  setNewSigner,
  signers,
  isLoading,
  transformedDataSigners,
  config_sign,
  refetchRegisterSigners,
}) => {
  const formFile = useForm({
    defaultValues: {
      signer: transformedDataSigners?.reduce((acc, cli) => {
        acc[cli.id] = true;
        return acc;
      }, {}),
    },
  });

  const errorsFile = formFile.formState.errors;

  const [loading, setLoading] = useState(false);
  const [visibleModalRegister, setVisibleModalRegister] = useState(false);
  const [sendSigners, setSendSigners] = useState([]);
  const [message, setMessage] = useState("");

  useEffect(() => {
    formFile.setValue("file_name", defaultValues.file_name);
    formFile.setValue("idDoc", defaultValues.idFile);
  }, [defaultValues]);

  useEffect(() => {
    const initialSigners = transformedDataSigners?.reduce((acc, cli) => {
      acc[cli.id] = true;
      return acc;
    }, {});

    setSendSigners(initialSigners);
  }, [transformedDataSigners]);

  const handleSubmitFile = async (data) => {
    const signers = {};
    setLoading(true);
    // Reestrutura os dados do signer
    Object.keys(data.signer).forEach((id) => {
      signers[id] = data.signer[id];
    });

    // Filtra os signers que têm o valor true
    const signatories_ids = Object.keys(sendSigners)
      .filter((id) => sendSigners[id])
      .map((id) => parseInt(id));

    const submitData = {
      signatories_ids,
      file_name: data.file_name,
      sale_id: idSale,
      file_id: data.idDoc,
      remind_interval: parseInt(data.remind_interval),
      message: message,
    };
//    console.log(submitData);

    const notification = toast.loading(
      "Por favor, aguarde a ação está sendo realizada..."
    );

    postSendContract(submitData)
      .then(() => {
        toast.update(notification, {
          render: "Contrato enviado com sucesso!",
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "success",
          isLoading: false,
        });
      })
      .catch((error) => {
        if (error == undefined) {
          error = "";
        }
        toast.update(notification, {
          render: `Não foi possível enviar o contrato! ${error}`,
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "error",
          isLoading: false,
        });
      })
      .finally(() => {
        setVisible(false);
        setLoading(false);
        setNewSigner([{}]);
        formFile.reset();
      });
  };

  const handleEditSigners = (cli, value) => {
//    console.log(cli);
//    console.log(value);

    setSendSigners((prevState) => ({
      ...prevState,
      [cli.id]: value,
    }));

    formFile.setValue(`signer[${cli.id}]`, value); // Atualiza o valor no formulário
  };
  const handleAddSigners = () => {
    setNewSigner([...newSigner, {}]);
  };
  const registerSigner = (data) => {
    setVisibleModalRegister(true);
  };

  const getFormErrorMessage = (name) => {
    return errorsFile[name] ? (
      <small className="p-error">{errorsFile[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  const splitName = (fullName) => {
    const nameParts = fullName.split(" ");
    const firstName = nameParts[0];
    const lastName = nameParts[1];

    return { firstName, lastName };
  };

  const remind_interval = [
    { value: "1", label: "1 Dia" },
    { value: "2", label: "2 Dias" },
    { value: "3", label: "3 Dias" },
    { value: "7", label: "7 Dias" },
    { value: "14", label: "14 Dias" },
  ];

  return (
    <Modal
      visible={visible}
      dynamicTitle={"Envio ClickSign"}
      onHide={() => setVisible(false)}
      position="center"
    >
      <form onSubmit={formFile.handleSubmit(handleSubmitFile)}>
        <div className="row">
          <div className="card p-3 bg-cyan-300 rounded-3 bg-opacity-75">
            <span className="text-blue-800">
              <i className="fa-solid fa-file me-1"></i>
              <b>{defaultValues?.file_name}</b>
            </span>
          </div>
        </div>
        <hr />
        <div className="row mb-4">
          <div className="d-flex justify-content-between">
            <div className="col-md-6 my-auto">
              <h4 className="text-success">
                <i className="fa-solid fa-user mx-2"></i>
                Signatários
              </h4>
            </div>
            <div className="col-md-6 text-end">
              <Button
                type="button"
                rounded
                outlined
                label="Signatário"
                size="small"
                severity="success"
                icon="fa fa-plus"
                onClick={registerSigner}
                className="mx-2 mt-1"
              />
            </div>
          </div>
        </div>
        <Input type="hidden" name="idDoc" control={formFile.control} />

        <div className="row" key="teste">
          {transformedDataSigners?.map((cli, index) => {
            const { firstName, lastName } = splitName(cli.name);
            return (
              <div className="col-md-4 mb-1" key={index}>
                <Toggle
                  name={`signer[${index}]`}
                  isRequired={true}
                  preValue={true}
                  onChange={(e) => handleEditSigners(cli, e)}
                  onLabel={`${firstName} ${lastName}`}
                  offLabel={`${firstName} ${lastName}`}
                  control={formFile.control}
                  getFormErrorMessage={getFormErrorMessage}
                />
              </div>
            );
          })}
        </div>

        <div className="row mb-4">
          <div className="col-md-12">
            <div className="col-md-12 my-auto">
              <h4 className="text-success">
                <i className="fa-solid fa-bell mx-2"></i>
                Dias para Lembrete
              </h4>
            </div>
            <div className="col-md-12">
              <Select
                isRequired={true}
                name="remind_interval"
                errors={errorsFile}
                label="Escolha"
                options={remind_interval}
                control={formFile.control}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="col-md-12 my-auto">
              <h4 className="text-success">
                <i className="fa-solid fa-message mx-2"></i>
                Mensagem
              </h4>
            </div>
            <div className="col-md-12">
              <InputTextarea
                name="message"
                aria-label="Mensagem"
                onChange={(e) => {
                  setMessage(e.target.value);
                }}
                placeholder="Digite sua mensagem aqui."
                rows={3}
                cols={30}
                control={formFile.control}
                className="w-100"
              />
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end mt-4">
          <Button
            label="Cancelar"
            type="button"
            onClick={() => setVisible(false)}
            icon="pi pi-times"
            loading={loading}
            className="p-button-text"
          />
          <Button
            label="Enviar"
            type="submit"
            icon="pi pi-check"
            loading={loading}
            autoFocus
          />
        </div>
      </form>
      <ModalRegisterSigners
        visible={visibleModalRegister}
        setVisible={setVisibleModalRegister}
        idSale={idSale}
        isLoading={isLoading}
        signers={signers}
        config_sign={config_sign}
        newSigner={newSigner}
        setNewSigner={setNewSigner}
        transformedDataSigners={transformedDataSigners}
        refetchRegisterSigners={refetchRegisterSigners}
      />
    </Modal>
  );
};
